// Single source of truth for the belt-badge PILL colours (Tailwind classes for compact
// chips/tables) — previously redefined identically across Students.jsx, Sessions.jsx,
// MyStudents.jsx and DemoView.jsx, except "White" and the unknown-grade fallback, which
// disagreed between a raw gray-100 tint and the semantic bg-nav-hover/text-muted pair.
// Standardised on the semantic pair (dark-safe by construction, no override needed) —
// matches the neutral-badge convention used elsewhere in the app (e.g. "No DOB").
//
// This is separate from BeltBadge.jsx's BELT_MAP, which holds the hex colours for the
// large inline-styled badge component and is already a single shared source.
export const BELT_STYLE = {
  White:  'bg-nav-hover text-muted',
  Yellow: 'bg-yellow-100 text-yellow-700',
  Orange: 'bg-orange-100 text-orange-700',
  Green:  'bg-green-100 text-green-700',
  Blue:   'bg-blue-100 text-blue-700',
  Red:    'bg-red-100 text-red-600',
  Brown:  'bg-amber-100 text-amber-800',
};

export const getBeltStyle = (grade) =>
  BELT_STYLE[grade] || (grade?.toLowerCase().includes('black') ? 'bg-gray-800 text-white' : 'bg-nav-hover text-muted');
